<app-content>
  <br>
  <app-spinner *ngIf='!error'>
    {{message}}
  </app-spinner>
  <app-alert
    *ngIf='error as v'
    [closable]='false'
    type='danger'
    [alertTittle]='v.status + " " + v.statusText'>
    {{ error.message }}
  </app-alert>
</app-content>
